<ul class="d-flex flex-wrap gap-1" [ngClass]="cssClasses()">
  @for (item of menuItems(); track $index) {
    <li>
      <fstr-link
        cssClasses="button button--accent"
        [button]="{
          url: item.url || null,
          text: item.title,
          routerLink: item.routerLink,
          queryParams: item.queryParams,
          fragment: item.fragment
        }"
      ></fstr-link>
    </li>
  }
</ul>
